import { render, staticRenderFns } from "./dataAssociationFlowButton.vue?vue&type=template&id=4df84e4b&"
import script from "./dataAssociationFlowButton.vue?vue&type=script&lang=js&"
export * from "./dataAssociationFlowButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports